import { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase";
import * as XLSX from "xlsx";
import { FiDownload } from "react-icons/fi";
export default function ExpensesSection() {
  const [expenses, setExpenses] = useState([]);
  const [filteredExpenses, setFilteredExpenses] = useState([]);

  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [branch, setBranch] = useState("");
  const [date, setDate] = useState("");
const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [editId, setEditId] = useState(null);
const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [durations, setDurations] = useState([]);
  const [totalExpense, setTotalExpense] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [todayExpense, setTodayExpense] = useState(0);
  const [yesterdayExpense, setYesterdayExpense] = useState(0);
  const [thisMonthExpense, setThisMonthExpense] = useState(0);
  const [lastMonthExpense, setLastMonthExpense] = useState(0);
  const [categoryReport, setCategoryReport] = useState({});
  const [filterDuration, setFilterDuration] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");

const [branchOpen, setBranchOpen] = useState(false);
const [filterBranch, setFilterBranch] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    fetchExpenses();
  }, []);
useEffect(() => {
  const currentMonth = new Date().getMonth();
  setSelectedMonths([currentMonth]);
}, []);
  useEffect(() => {
  applyFilters();
  calculateReports();
}, [
  expenses,
  filterBranch,
  filterDuration,
  startDate,
  endDate,
  searchTerm
]);

  const calculateReports = () => {
  const now = new Date();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);

  const thisMonth = now.getMonth();
  const thisYear = now.getFullYear();

  const lastMonthDate = new Date();
  lastMonthDate.setMonth(now.getMonth() - 1);

  let todayTotal = 0;
  let yesterdayTotal = 0;
  let thisMonthTotal = 0;
  let lastMonthTotal = 0;

  let categoryTotals = {};

  expenses.forEach((e) => {
    const expDate = new Date(e.date);
    expDate.setHours(0,0,0,0);

    const expMonth = expDate.getMonth();
    const expYear = expDate.getFullYear();

    // ✅ TODAY
    if (expDate.getTime() === today.getTime()) {
      todayTotal += Number(e.amount);
    }

    // ✅ YESTERDAY
    if (expDate.getTime() === yesterday.getTime()) {
      yesterdayTotal += Number(e.amount);
    }

    // ✅ THIS MONTH
    if (expMonth === thisMonth && expYear === thisYear) {
      thisMonthTotal += Number(e.amount);
    }

    // ✅ LAST MONTH
    if (
      expMonth === lastMonthDate.getMonth() &&
      expYear === lastMonthDate.getFullYear()
    ) {
      lastMonthTotal += Number(e.amount);
    }

    // ✅ CATEGORY REPORT
    if (!categoryTotals[e.category]) {
      categoryTotals[e.category] = 0;
    }

    categoryTotals[e.category] += Number(e.amount);
  });

  setTodayExpense(todayTotal);
  setYesterdayExpense(yesterdayTotal);
  setThisMonthExpense(thisMonthTotal);
  setLastMonthExpense(lastMonthTotal);
  setCategoryReport(categoryTotals);
};
const toggleBranch = (branch) => {
  let updated;

  if (filterBranch.includes(branch)) {
    updated = filterBranch.filter((b) => b !== branch);
  } else {
    updated = [...filterBranch, branch];
  }

  setFilterBranch(updated);

};
  const fetchExpenses = async () => {
    const snap = await getDocs(collection(db, "expenses"));
    const list = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    list.sort((a, b) => new Date(b.date) - new Date(a.date));

    setExpenses(list);
  };
const handleDurationChange = (value) => {
  if (durations.includes(value)) {
    setDurations(durations.filter((d) => d !== value));
  } else {
    setDurations([...durations, value]);
  }

  // When duration changes, remove date filter
  setSelectedDate(null);
};

useEffect(() => {
  const handleClickOutside = (event) => {
    if (!event.target.closest(".branch-dropdown")) {
      setBranchOpen(false);
    }
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);
 const applyFilters = () => {

  const today = new Date();
  today.setHours(0,0,0,0);

  let filtered = expenses.filter((e) => {

    const expDate = new Date(e.date);
    expDate.setHours(0,0,0,0);
// Search filter
if (searchTerm) {
  const text = searchTerm.toLowerCase();

  if (
    !e.category?.toLowerCase().includes(text) &&
    !e.description?.toLowerCase().includes(text)
  ) {
    return false;
  }
}
    // Branch filter
    if (filterBranch.length > 0 && !filterBranch.includes(e.branch)) {
      return false;
    }

    // Duration filter
    if (filterDuration === "today") {
      if (expDate.getTime() !== today.getTime()) return false;
    }

    if (filterDuration === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0,0,0,0);

      if (expDate.getTime() !== yesterday.getTime()) return false;
    }

    if (filterDuration === "1_week") {
      const last7 = new Date();
      last7.setDate(today.getDate() - 7);

      if (expDate < last7) return false;
    }

    if (filterDuration === "30_days") {
      const last30 = new Date();
      last30.setDate(today.getDate() - 30);

      if (expDate < last30) return false;
    }

    if (filterDuration === "60_days") {
      const last60 = new Date();
      last60.setDate(today.getDate() - 60);

      if (expDate < last60) return false;
    }

    // Start date
    if (startDate) {
      const start = new Date(startDate);
      start.setHours(0,0,0,0);

      if (expDate < start) return false;
    }

    // End date
    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23,59,59,999);

      if (expDate > end) return false;
    }
    return true;
  });


const isAnyFilter =
  filterDuration !== "" ||
  startDate !== "" ||
  endDate !== "" ||
  searchTerm !== "";

if (!isAnyFilter) {
  setFilteredExpenses([]);
  setTotalExpense(0);
  setIsFilterApplied(false); // 👈 important
  return;
}

if (filterDuration || startDate || endDate || searchTerm) {
  setIsFilterApplied(true);
} else {
  setIsFilterApplied(false);
}

setFilteredExpenses(filtered);

const total = filtered.reduce(
  (sum, e) => sum + Number(e.amount),
  0
);

setTotalExpense(total);
};

  const handleAddOrUpdate = async () => {
    if (!amount || !category || !branch || !date) {
  setShowErrorModal(true);
  return;
}

    if (editId) {
      await updateDoc(doc(db, "expenses", editId), {
        amount: Number(amount),
        category,
        description,
        branch,
        date,
      });
      setEditId(null);
    } else {
      await addDoc(collection(db, "expenses"), {
        amount: Number(amount),
        category,
        description,
        branch,
        date,
        createdAt: new Date(),
      });
    }

    setAmount("");
    setCategory("");
    setDescription("");
    setBranch("");
    setDate("");
    fetchExpenses();
  };

  const handleEdit = (exp) => {
    setEditId(exp.id);
    setAmount(exp.amount);
    setCategory(exp.category);
    setDescription(exp.description);
    setBranch(exp.branch);
    setDate(exp.date);
  };

  const handleCancelEdit = () => {
  setEditId(null);
  setAmount("");
  setCategory("");
  setDescription("");
  setBranch("");
  setDate("");
};

  const handleDelete = async () => {
  if (!deleteId) return;

  await deleteDoc(doc(db, "expenses", deleteId));

  setShowDeleteModal(false);
  setDeleteId(null);

  fetchExpenses();
};

  const exportExcel = () => {

  const data = filteredExpenses.map((e) => ({
    Date: formatDate(e.date),
    Branch: e.branch,
    Category: e.category,
    Description: e.description || "-",
    Amount: e.amount,
  }));

  // ✅ Calculate total based on filtered data
  const totalAmount = filteredExpenses.reduce(
    (sum, e) => sum + Number(e.amount),
    0
  );

  // ✅ Add total row
  data.push({});
data.push({
Date: "",
Branch: "",
Category: "",
Description: "TOTAL EXPENSES",
Amount: totalAmount,
});

  const worksheet = XLSX.utils.json_to_sheet(data);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

  // ✅ Indian date format for filename
    // ✅ Indian date format
  const formatIndianDate = (date) => {
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  let fileName = "Expenses";

if (startDate && endDate) {

fileName = `Expenses_${formatDate(startDate)}_to_${formatDate(endDate)}`;

}

else if (filterDuration) {

fileName = `Expenses_${filterDuration}`;

}

else if (filterBranch.length === 1) {

fileName = `Expenses_${filterBranch[0]}`;

}

else {

const today = new Date();
fileName = `Expenses_${formatDate(today)}`;

}

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

  const formatDate = (date) => {
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  return (
    <div className="p-4 md:p-6 bg-gray-100 min-h-screen">

      <h2 className="text-2xl font-bold mb-4 text-[#204080]">
        Expenses Tracker
      </h2>
<div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">

  <div className="bg-blue-100 text-blue-800 p-4 rounded-xl shadow text-center">
    <p className="text-sm">Today's Expense</p>
    <h3 className="text-xl font-bold">₹{todayExpense}</h3>
  </div>

  <div className="bg-green-100 text-green-800 p-4 rounded-xl shadow text-center">
    <p className="text-sm">Yesterday's Expense</p>
    <h3 className="text-xl font-bold">₹{yesterdayExpense}</h3>
  </div>

  <div className="bg-purple-100 text-purple-800 p-4 rounded-xl shadow text-center">
    <p className="text-sm">This Month's Expense</p>
    <h3 className="text-xl font-bold">₹{thisMonthExpense}</h3>
  </div>

  <div className="bg-yellow-100 text-yellow-800 p-4 rounded-xl shadow text-center">
    <p className="text-sm">Last Month's Expense</p>
    <h3 className="text-xl font-bold">₹{lastMonthExpense}</h3>
  </div>
</div>
      {/* ADD / EDIT FORM */}
      <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 mb-6">

        <h3 className="text-lg font-semibold text-[#204080] mb-4">
          {editId ? "Edit Expense" : "Add Expense"}
        </h3>

        <div className="flex flex-wrap gap-3">

          <input
            type="text"
            placeholder="Category (Electricity, WiFi, Rent)"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="border rounded px-3 py-2 text-sm"
          />

          <input
            type="number"
            placeholder="Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="border rounded px-3 py-2 text-sm"
          />

          <input
            type="text"
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="border rounded px-3 py-2 text-sm"
          />

          <select
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
            className="border rounded px-3 py-2 text-sm"
          >
            <option value="">Select Branch</option>
            <option value="Gajuwaka">Gajuwaka</option>
            <option value="Kurmannapalem">Kurmannapalem</option>
          </select>

          <input
    type="date"
    value={date}
    onChange={(e) => setDate(e.target.value)}
    className="border rounded px-3 py-2 text-sm"
  />

          {editId ? (
  <>
    <button
      onClick={handleAddOrUpdate}
      className="px-4 py-2 rounded bg-[#204080] text-white"
    >
      Save
    </button>

    <button
      onClick={handleCancelEdit}
      className="px-4 py-2 rounded bg-gray-400 text-white"
    >
      Cancel
    </button>
  </>
) : (
  <button
    onClick={handleAddOrUpdate}
    className="px-4 py-2 rounded bg-[#204080] text-white"
  >
    Add
  </button>
)}
          

        </div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 mb-6">
<div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
  <h3 className="text-lg font-semibold text-[#204080]">
    Filter Expenses
  </h3>

 <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
    <button
      onClick={() => {
        setFilterBranch([]);
        setFilterDuration("");
        setStartDate("");
        setEndDate("");
        setSearchTerm("");
      }}
      className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
    >
      Reset Filters
    </button>

   <button
  onClick={exportExcel}
  className="flex items-center gap-2 px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700 transition"
>
  <FiDownload size={16} />
  Export Excel
</button>
  </div>
</div>
<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">

{/* BRANCH */}
<div className="relative branch-dropdown">

<p className="text-sm font-semibold mb-1">Branch</p>

<button
onClick={() => setBranchOpen(!branchOpen)}
className="border rounded-lg px-3 py-2 text-sm bg-white w-full flex justify-between items-center truncate"
>
{filterBranch.length === 2
  ? "All Branches"
  : filterBranch.length === 0
  ? "All Branches"
  : filterBranch.join(", ")}
</button>

{branchOpen && (
  <div className="absolute left-0 bg-white border rounded-lg shadow p-3 mt-1 w-full z-10 space-y-2">

{/* ALL BRANCHES */}

<label className="flex items-center gap-2 text-sm">
<input
type="checkbox"
checked={
  filterBranch.length === 2

}
onChange={() => {
  if (filterBranch.length === 2) {
    setFilterBranch([]);
  } else {
    setFilterBranch(["Gajuwaka", "Kurmannapalem"]);
  }
}}
/>
All Branches
</label>

{/* GAJUWAKA */}

<label className="flex items-center gap-2 text-sm">
<input
type="checkbox"
checked={filterBranch.includes("Gajuwaka")}
onChange={() => toggleBranch("Gajuwaka")}
/>
Gajuwaka
</label>

{/* KURMANNAPALEM */}

<label className="flex items-center gap-2 text-sm">
<input
type="checkbox"
checked={filterBranch.includes("Kurmannapalem")}
onChange={() => toggleBranch("Kurmannapalem")}
/>
Kurmannapalem
</label>

</div>
)}

</div>

{/* DURATION */}

<div>

<p className="text-sm font-semibold mb-1">Duration</p>

<select
  value={filterDuration}
  onChange={(e) => {
    setFilterDuration(e.target.value);
    setBranchOpen(false); // ✅ ADD THIS
  }}
  className="border rounded-lg px-3 py-2 text-sm bg-white w-full"
>

<option value="">Select</option>
<option value="today">Today</option>
<option value="yesterday">Yesterday</option>
<option value="1_week">Last 7 Days</option>
<option value="30_days">Last 30 Days</option>
<option value="60_days">Last 60 Days</option>

</select>

</div>
<div className="flex items-end justify-center md:col-span-1">
  <span className="text-black text-sm font-bold mb-2">
    OR
  </span>
</div>
{/* START DATE */}

<div>
  <p className="text-sm font-semibold mb-1">Start Date</p>

  <input
    type="date"
    value={startDate}
    onChange={(e) => {
      setStartDate(e.target.value);
      setFilterDuration("");
      setBranchOpen(false);
    }}
    className="border rounded-lg px-3 py-2 text-sm bg-white w-full"
  />
</div>

{/* END DATE */}

<div>
  <p className="text-sm font-semibold mb-1">End Date</p>

  <input
  type="date"
  value={endDate}
  max={new Date().toISOString().split("T")[0]}   // ✅ disables future dates
  onChange={(e) => {
    setEndDate(e.target.value);
    setFilterDuration("");
    setBranchOpen(false);
  }}
  className="border rounded-lg px-3 py-2 text-sm bg-white w-full"
/>
</div>

</div>

</div>
{isFilterApplied && (
  <div className="bg-white p-6 rounded-xl shadow-md border border-gray-200 mb-4 flex justify-between items-center">

<h3 className="text-lg font-semibold text-[#204080]">
Filtered Expenses
</h3>

<p className="text-xl font-bold text-green-600">
₹ {totalExpense}
</p>

</div>
)}
      {/* TABLE */}
{isFilterApplied && (
  <div className="bg-white rounded-xl shadow overflow-x-auto">

        <table className="w-full text-sm text-center border-collapse">

          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 border-b text-[#204080]">Date</th>
              <th className="px-3 py-2 border-b text-[#204080]">Branch</th>
              <th className="px-3 py-2 border-b text-[#204080]">Category</th>
              <th className="px-3 py-2 border-b text-[#204080]">Description</th>
              <th className="px-3 py-2 border-b text-[#204080]">Amount</th>
              <th className="px-3 py-2 border-b text-[#204080]">Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredExpenses.map((e) => (
              <tr key={e.id} className="border-t hover:bg-gray-50">

                <td className="px-3 py-2">{formatDate(e.date)}</td>
                <td className="px-3 py-2">{e.branch}</td>
                <td className="px-3 py-2">{e.category}</td>
                <td className="px-3 py-2">{e.description || "-"}</td>
                <td className="px-3 py-2 font-semibold">₹{e.amount}</td>

                <td className="px-3 py-2 space-x-2">

                  <button
                    onClick={() => handleEdit(e)}
                    className="text-blue-600 hover:underline"
                  >
                    Edit
                  </button>

                  <button
  onClick={() => {
    setDeleteId(e.id);
    setShowDeleteModal(true);
  }}
  className="text-red-600 hover:underline"
>
  Delete
</button>

                </td>

              </tr>
            ))}
          </tbody>

        </table>

        {filteredExpenses.length === 0 && (
          <p className="text-gray-500 p-4">No expenses found</p>
        )}

      </div>
      )}
{showDeleteModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">

    <div className="bg-white p-6 rounded-lg shadow-lg w-[320px] text-center">

      <h3 className="text-lg font-semibold mb-3">
        Delete Expense
      </h3>

      <p className="text-gray-600 mb-5">
        Are you sure you want to delete this expense?
      </p>

      <div className="flex justify-center gap-3">

        <button
          onClick={() => setShowDeleteModal(false)}
          className="px-4 py-2 border rounded"
        >
          Cancel
        </button>

        <button
          onClick={handleDelete}
          className="px-4 py-2 bg-red-600 text-white rounded"
        >
          Delete
        </button>

      </div>

    </div>

  </div>
)}
{showErrorModal && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">

    <div className="bg-white p-6 rounded-lg shadow-lg w-[320px] text-center">

      <h3 className="text-lg font-semibold mb-3 text-red-600">
        Missing Details
      </h3>

      <p className="text-gray-600 mb-5">
        Please enter Category, Amount and Branch before saving.
      </p>

      <button
        onClick={() => setShowErrorModal(false)}
        className="px-4 py-2 bg-[#204080] text-white rounded"
      >
        OK
      </button>

    </div>

  </div>
)}
    </div>
  );
}